module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-1-min.6e9000c1.jpg";